// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"63849":"00ca24665404cf7b","75185":"9f3dbe6d06d1e3de"}[chunkId] + ".css";
};